/**
 * @generated SignedSource<<3a71ed81107c609713df0e44fbe03745>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgendaWaitlistRendererQuery$variables = {
  courseIds?: ReadonlyArray<string> | null | undefined;
  date: string;
  facilityId: string;
};
export type AgendaWaitlistRendererQuery$data = {
  readonly node: {
    readonly agendas?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly queueSlot: {
            readonly bookings: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly id: string;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly id: string;
          };
          readonly waitlistRestrictions: {
            readonly edges: ReadonlyArray<{
              readonly liftAt: string | null | undefined;
              readonly node: {
                readonly id: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"AgendaWaitlistBodyFragment">;
  } | null | undefined;
};
export type AgendaWaitlistRendererQuery = {
  response: AgendaWaitlistRendererQuery$data;
  variables: AgendaWaitlistRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "courseIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "facilityId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "dateGte",
    "variableName": "date"
  },
  {
    "kind": "Variable",
    "name": "dateLte",
    "variableName": "date"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": {
    "direction": "ASC",
    "field": "REQUESTED_DATE_TIME"
  }
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  {
    "kind": "Variable",
    "name": "courseIds",
    "variableName": "courseIds"
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": [
      "WAITLIST"
    ]
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "liftAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  },
  (v6/*: any*/)
],
v14 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v15 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Request",
    "kind": "LinkedField",
    "name": "request",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "time",
        "storageKey": null
      },
      (v5/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AgendaWaitlistRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AgendaWaitlistBodyFragment"
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "AgendaConnection",
                "kind": "LinkedField",
                "name": "agendas",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agenda",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "QueueSlot",
                            "kind": "LinkedField",
                            "name": "queueSlot",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": "bookings",
                                "args": [
                                  (v6/*: any*/)
                                ],
                                "concreteType": "BookingConnection",
                                "kind": "LinkedField",
                                "name": "__queueSlot_bookings_connection",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BookingEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v9/*: any*/)
                                ],
                                "storageKey": "__queueSlot_bookings_connection(orderBy:{\"direction\":\"ASC\",\"field\":\"REQUESTED_DATE_TIME\"})"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "waitlistRestrictions",
                            "args": (v10/*: any*/),
                            "concreteType": "AgendaBookingRulesConnection",
                            "kind": "LinkedField",
                            "name": "bookingRules",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgendaBookingRulesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Facility",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AgendaWaitlistRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "AgendaConnection",
                "kind": "LinkedField",
                "name": "agendas",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agenda",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "QueueSlot",
                            "kind": "LinkedField",
                            "name": "queueSlot",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": "queueCount",
                                "args": null,
                                "concreteType": "BookingConnection",
                                "kind": "LinkedField",
                                "name": "bookings",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "count",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v13/*: any*/),
                                "concreteType": "BookingConnection",
                                "kind": "LinkedField",
                                "name": "bookings",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BookingEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v5/*: any*/),
                                          {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isBooking"
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "canUpdate",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "writeAccess",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "startSlot",
                                            "plural": false,
                                            "selections": [
                                              (v7/*: any*/),
                                              (v5/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Agenda",
                                                    "kind": "LinkedField",
                                                    "name": "agenda",
                                                    "plural": false,
                                                    "selections": [
                                                      (v12/*: any*/),
                                                      (v5/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "QueueSlot",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": (v14/*: any*/),
                                            "concreteType": "RoundConnection",
                                            "kind": "LinkedField",
                                            "name": "rounds",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "RoundEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v5/*: any*/),
                                                      (v7/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "TransportationType",
                                                        "kind": "LinkedField",
                                                        "name": "transportationType",
                                                        "plural": false,
                                                        "selections": [
                                                          (v5/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "code",
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "CourseLayout",
                                                        "kind": "LinkedField",
                                                        "name": "courseLayout",
                                                        "plural": false,
                                                        "selections": [
                                                          (v5/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "holeCount",
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": null,
                                                        "kind": "LinkedField",
                                                        "name": "player",
                                                        "plural": false,
                                                        "selections": [
                                                          (v7/*: any*/),
                                                          (v5/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "firstName",
                                                            "storageKey": null
                                                          },
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "lastName",
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v8/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v9/*: any*/)
                                            ],
                                            "storageKey": "rounds(first:100)"
                                          },
                                          {
                                            "alias": null,
                                            "args": (v14/*: any*/),
                                            "filters": null,
                                            "handle": "connection",
                                            "key": "booking_rounds",
                                            "kind": "LinkedHandle",
                                            "name": "rounds"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v15/*: any*/),
                                            "type": "StandardBooking",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v15/*: any*/),
                                            "type": "LessonBooking",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v9/*: any*/)
                                ],
                                "storageKey": "bookings(first:1000,orderBy:{\"direction\":\"ASC\",\"field\":\"REQUESTED_DATE_TIME\"})"
                              },
                              {
                                "alias": null,
                                "args": (v13/*: any*/),
                                "filters": [
                                  "orderBy"
                                ],
                                "handle": "connection",
                                "key": "queueSlot_bookings",
                                "kind": "LinkedHandle",
                                "name": "bookings"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Facility",
                            "kind": "LinkedField",
                            "name": "facility",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Club",
                                "kind": "LinkedField",
                                "name": "club",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "supportsPublic",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "waitlistRestrictions",
                            "args": (v10/*: any*/),
                            "concreteType": "AgendaBookingRulesConnection",
                            "kind": "LinkedField",
                            "name": "bookingRules",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgendaBookingRulesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Facility",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "67c51d4610ab15ee8e0f7e7a4d4b265b",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": null
        }
      ]
    },
    "name": "AgendaWaitlistRendererQuery",
    "operationKind": "query",
    "text": "query AgendaWaitlistRendererQuery(\n  $facilityId: ID!\n  $date: Date!\n  $courseIds: [ID!]\n) {\n  node(id: $facilityId) {\n    __typename\n    ... on Facility {\n      ...AgendaWaitlistBodyFragment\n      agendas(dateGte: $date, dateLte: $date) {\n        edges {\n          node {\n            id\n            queueSlot {\n              id\n              bookings(first: 1000, orderBy: {field: REQUESTED_DATE_TIME, direction: ASC}) {\n                edges {\n                  node {\n                    __typename\n                    id\n                  }\n                  cursor\n                }\n                pageInfo {\n                  endCursor\n                  hasNextPage\n                }\n              }\n            }\n            waitlistRestrictions: bookingRules(type: [WAITLIST], courseIds: $courseIds) {\n              edges {\n                liftAt\n                node {\n                  __typename\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AgendaWaitlistBodyFragment on Facility {\n  agendas(dateGte: $date, dateLte: $date) {\n    edges {\n      node {\n        id\n        ...AgendaWaitlistBookings_Agenda\n        facility {\n          club {\n            supportsPublic\n            id\n          }\n          id\n        }\n        waitlistRestrictions: bookingRules(type: [WAITLIST], courseIds: $courseIds) {\n          edges {\n            liftAt\n            node {\n              __typename\n              id\n            }\n          }\n        }\n        queueSlot {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment AgendaWaitlistBooking_Booking on Booking {\n  __isBooking: __typename\n  id\n  canUpdate\n  writeAccess\n  ... on StandardBooking {\n    request {\n      time\n      id\n    }\n  }\n  startSlot {\n    __typename\n    id\n    ... on QueueSlot {\n      id\n      agenda {\n        date\n        id\n      }\n    }\n  }\n  rounds(first: 100) {\n    edges {\n      node {\n        id\n        __typename\n        transportationType {\n          id\n          code\n        }\n        courseLayout {\n          id\n          holeCount\n        }\n        player {\n          __typename\n          id\n          firstName\n          lastName\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AgendaWaitlistBookings_Agenda on Agenda {\n  id\n  date\n  queueSlot {\n    id\n    queueCount: bookings {\n      count\n    }\n    bookings(first: 1000, orderBy: {field: REQUESTED_DATE_TIME, direction: ASC}) {\n      edges {\n        node {\n          __typename\n          id\n          ... on StandardBooking {\n            request {\n              time\n              id\n            }\n          }\n          ... on LessonBooking {\n            request {\n              time\n              id\n            }\n          }\n          ...AgendaWaitlistBooking_Booking\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  facility {\n    club {\n      supportsPublic\n      id\n    }\n    id\n  }\n  waitlistRestrictions: bookingRules(type: [WAITLIST], courseIds: $courseIds) {\n    edges {\n      liftAt\n      node {\n        __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "24814703f7d5477400de998652a84baf";

export default node;
